// Shared Tailwind class sets for elements that appear in several components.

// Square outlined icon button used in the dark navbar (search, theme, language).
export const ICON_BUTTON =
  "w-9 h-9 sm:w-10 sm:h-10 rounded-xl border border-white/15 text-white/80 hover:text-white hover:border-white/40 flex items-center justify-center transition-colors";

// Outlined button for dark sections, next to a filled `.btn-rose`.
export const GHOST_BUTTON_DARK =
  "inline-flex items-center gap-2 rounded-xl border border-white/25 px-5 py-3 text-sm font-semibold text-white hover:border-white/60 hover:bg-white/5 transition-colors";
